import "./ModalOverlay.scss";

export function ModalOverlay({ children, ...props })
{
    return <div styleName="modal-overlay" {...props}>{children}</div>
}